import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExternalDataService } from './services/external-data/external-data.service';
import { ExternalNavigationService } from './services/external-navigation/external-navigation.service';
import { ExternalStyleService } from './services/external-style/external-style.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public loadingStylesheet = true;

  constructor(
    private externalDataService: ExternalDataService,
    private externalStyleService: ExternalStyleService,
    private externalNavigationService: ExternalNavigationService,
    private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');

    this.externalDataService.$language.subscribe((lang) => this.translateService.use(lang));
    this.externalStyleService.$loading.subscribe((loading) => (this.loadingStylesheet = loading));
  }
}
